import {Translate} from 'react-redux-i18n';

import {planPropTypes} from '../../../../utils/propTypes';

const PlanConditions = ({plan}) => {
  if (!plan.depositor) {
    return <Translate value="subscriptions.plans.clientOrganisations"/>;
  }

  if (Number.isInteger(plan.maxEmployees) && (plan.maxEmployees > 0)) {
    return <Translate
      value="subscriptions.plans.smallOrganisations"
      count={plan.maxEmployees}
    />;
  }

  return null;
};

PlanConditions.propTypes = {
  plan: planPropTypes().isRequired
};

export default PlanConditions;
